import React, { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

import { ROUTES } from 'consts';
import { UnauthLayout } from 'layouts';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

export const UnauthNavigator = () => {
  const { orgSlug, isLoggedIn } = useAppSelector(selectCurrentUserInfo);
  const navigate = useNavigate();
  const location = useLocation();

  const { from } = location.state
    ? (location.state as { from: string })
    : { from: `/${ROUTES.ORG_SLUG.replace(':orgSlug', orgSlug)}` };

  useEffect(() => {
    if (isLoggedIn) {
      navigate(from);
    }
  }, [isLoggedIn, navigate, from]);

  return (
    <UnauthLayout>
      <Outlet />
    </UnauthLayout>
  );
};
